import util from "./_util";

const { request } = util;

export default {
  //上传文件表单信息
  organUpload(data) {
    return request.post("/organ/upload_data", data);
  },
};
